import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductInsurancesComponent extends Vue {
    @Prop()
    productsOfTypeInsurance: flights.ProductModel[];

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    mounted() {
        this.productsOfTypeInsurance.forEach((product) => {
            const stepNumber = product.product.stepNumber;
            const kitId = product.product?.kitId || '';
            const id = product.product.id;
            const label = `product.step${stepNumber}.kit${kitId}.id${id}`;

            if(!this.gaAlreadySubmitted.includes(label)){
                (<any>this).$ga.sendEvent('product',
                    'display',
                    label,
                    this.gaParams
                );
                this.gaAlreadySubmitted.push(label);
            }
        });
    }

    getProductIcon(iconName: string): string {
        let urlPrefix = '/i/icons/lg/';

        if (G2S.config.theme === 'aviasales') {
            urlPrefix = '/themes/aviasales/i/icons/lg/';
        }

        return urlPrefix + iconName + '.svg';
    }

    onProductTerms() {
        (<any>this).$root.$refs.dialogContent.open('insurance.terms', (<any>this).$i18.t('label_terms_insurance'));
        const product = (<any>this).productsOfTypeInsurance[0];
        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );
    }

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);

        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        if (value) {
            product.choiceType = api.ProductChoiceType.manualAccepted;
        }

        this.$emit('product-selection-change', product, value);

        (<any>this).$ga.sendEvent('product',
            value ? 'btn.ok' : 'btn.cancel',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );
    }
}
